// extracted by mini-css-extract-plugin
export var sliderRange = "_o2-2";
export var sliderRoot = "_o2-0";
export var sliderThumb = "_o2-3";
export var sliderTrack = "_o2-1";